import { apiClient } from './api/client';

export async function getAdminMembers({ offset = 0, limit = 100 } = {}) {
  return apiClient.get('/api/admin/members', { params: { offset, limit } });
}

export async function getAdminHealth() {
  return apiClient.get('/api/admin/health');
}

// --- Admin DB tools (development) ---

export async function getAdminDbTables() {
  return apiClient.get('/api/admin/db/tables');
}

export async function getAdminDbTableRows(table, { offset = 0, limit = 50 } = {}) {
  if (!table) throw new Error('table is required');
  return apiClient.get(`/api/admin/db/tables/${encodeURIComponent(table)}/rows`, { params: { offset, limit } });
}

export async function createAdminDbRow(table, row) {
  if (!table) throw new Error('table is required');
  if (!row || typeof row !== 'object') throw new Error('row (object) is required');
  return apiClient.post(`/api/admin/db/tables/${encodeURIComponent(table)}/rows`, row);
}

export async function patchAdminDbRow(table, pk, patch) {
  if (!table) throw new Error('table is required');
  if (!pk) throw new Error('pk is required');
  if (!patch || typeof patch !== 'object') throw new Error('patch (object) is required');
  return apiClient.patch(`/api/admin/db/tables/${encodeURIComponent(table)}/rows/${encodeURIComponent(pk)}`, patch);
}

export async function deleteAdminDbRow(table, pk) {
  if (!table) throw new Error('table is required');
  if (!pk) throw new Error('pk is required');
  return apiClient.delete(`/api/admin/db/tables/${encodeURIComponent(table)}/rows/${encodeURIComponent(pk)}`);
}
